import { useCallback, useEffect, useState } from "react";
import { getPartnerGeneralInfo } from "../../../components/home/functions";
import MobileSection from "../../ui/MobileSection";
import MobileSkeleton from "../../ui/MobileSkeleton";
import MobileError from "../../ui/MobileError";

const PARTNER_STATS = [
  { key: "approved", label: "Pedidos com pagamento aprovado" },
  { key: "hold", label: "Pedidos aguardando Manafix" },
  { key: "awaiting", label: "Pedidos aguardando cliente" },
  { key: "delivered", label: "Pedidos entregues (aguardando finalização)" },
];

function StatRow({ label, value }) {
  return (
    <div className="flex items-center justify-between gap-4 border-b border-primary/20 py-3 last:border-b-0">
      <span className="text-sm text-laranjinha/70">{label}</span>
      <span className="text-lg font-semibold text-laranjinha">{value ?? "—"}</span>
    </div>
  );
}

export default function MobilePartnerHome({ user }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState({});
  const [hasLoaded, setHasLoaded] = useState(false);

  const loadData = useCallback(async () => {
    if (!user?.store) {
      return;
    }
    setLoading(true);
    setError(null);
    const response = await getPartnerGeneralInfo(user.token);
    if (response?.type === "error") {
      setError(response.message ?? "Não foi possível carregar o resumo.");
      setData({});
    } else {
      setData(response?.data ?? {});
    }
    setHasLoaded(true);
    setLoading(false);
  }, [user?.store, user.token]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  if (!user?.store) {
    return (
      <MobileSection title="Home">
        <p className="text-sm text-laranjinha/80">Você não possui um reino parceiro</p>
      </MobileSection>
    );
  }

  if (loading && !hasLoaded) {
    return (
      <div aria-label="Carregando resumo" role="status">
        <MobileSkeleton lines={4} />
      </div>
    );
  }

  if (error && !hasLoaded) {
    return <MobileError message={error} onRetry={loadData} />;
  }

  return (
    <div className="flex flex-col">
      <MobileSection title="Bem-vindo(a)">
        <p className="text-sm text-laranjinha/80">
          Seção de <strong>{user.store.name}</strong>
        </p>
      </MobileSection>

      <div className="flex items-center justify-end border-b border-primary/30 bg-mgs-bg px-4 py-2">
        <button
          type="button"
          onClick={loadData}
          disabled={loading}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-primary/50 px-3 text-sm font-medium text-laranjinha/80 hover:bg-monao disabled:opacity-50"
        >
          {loading ? "Atualizando…" : "Atualizar"}
        </button>
      </div>

      <MobileSection title="Resumo">
        {PARTNER_STATS.map((stat) => (
          <StatRow key={stat.key} label={stat.label} value={data?.[stat.key]} />
        ))}
      </MobileSection>
    </div>
  );
}
